import { format, isSameDay, isSameMonth, isSameYear } from 'date-fns';
import { DateRange } from 'react-day-picker';

export const getFormattedDatesRange = (datesRange: DateRange) => {
  if (!datesRange.from) return null;
  if (!datesRange.to || isSameDay(datesRange.from, datesRange.to)) return format(datesRange.from, 'MMMM d, yyyy');

  if (isSameMonth(datesRange.from, datesRange.to)) {
    return `${format(datesRange.from, 'MMMM d')} - ${format(datesRange.to, 'd, yyyy')}`;
  }

  if (isSameYear(datesRange.from, datesRange.to)) {
    return `${format(datesRange.from, 'MMMM d')} - ${format(datesRange.to, 'MMMM d, yyyy')}`;
  }

  return `${format(datesRange.from, 'MMMM d, yyyy')} - ${format(datesRange.to, 'MMMM d, yyyy')}`;
};
